export const saveFormData = (key, values) => {
  sessionStorage.setItem(key, JSON.stringify(values));
};
